export default __webpack_public_path__ + "static/media/stagger3.288e8692.png";